import React, { useState, useEffect } from "react";
import { mdiCog } from "@mdi/js";
import { getUrl } from "utils/utils";
import "react-dropdown/style.css";
import LayoutNew from "common/LayoutNew";
import { Breadcrumb } from "common/Breadcrumb";
import { TitlePage } from "common/TitlePage";
import { getUserLogin } from "utils/utils";
import { GetRoleParentCap1ByLink } from "utils/utils";
import { pushNotification } from "utils/notifications";
import iconCustomer from "Resources/ImagesNew/Group2196.png";
import DanhSachNguoiDungApi from "../../../service/HeThong/DanhSachNguoiDungApi";
export const MKNguoiDung = () => {
    document.title = "Đổi mật khẩu người dùng";

    const [getLink, setGetLink] = useState();

    useEffect(() => {
    }, []);
    const init = {
        userName: getUserLogin().UserName,
        hoten: "",
        sodienthoai: "",
        email: "",
        matkhaucu: "",
        matkhaumoi: "",
        nhaplaimatkhaumoi: ""
    }
    const [dataUser, setDataUser] = useState(init);

    useEffect(() => {
        //GetFullUser();
    }, []);

    // const GetFullUser = () => {
    //     DanhSachNguoiDungApi.chitietnguoidungdaily(dataUser.userName).then((response) => {
    //         if (response.status === 200) {
    //             if (response.data) {
    //                 setDataUser({
    //                     ...dataUser,
    //                     hoten: response.data.FullName,
    //                     sodienthoai: response.data.Email,
    //                     email: response.data.Phone,
    //                 })
    //             }
    //         }
    //     });
    // }
    const onChangeText = (field, e) => updateStateThongTin(field, e.target.value);
    const updateStateThongTin = (field, value) => {
        const thongtin = { ...dataUser };
        thongtin[field] = value;
        setDataUser(thongtin);
    };
    const onSave = () => {
        if (dataUser.matkhaucu == '') {
            pushNotification(
                "Nhập mật khẩu cũ",
                "error",
                "TOP_RIGHT",
                2000
            );
            return;
        }
        if (dataUser.matkhaumoi == '') {
            pushNotification(
                "Nhập mật khẩu mới",
                "error",
                "TOP_RIGHT",
                2000
            );
            return
        }

        if (dataUser.matkhaumoi.length < 6) {
            pushNotification(
                "Mật khẩu mới phải có ít nhất 6 ký tự",
                "error",
                "TOP_RIGHT",
                2000
            );
            return;
        }
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).+$/;
        if (!passwordRegex.test(dataUser.matkhaumoi)) {
            pushNotification(
                "Mật khẩu mới phải chứa ít nhất 1 chữ cái và 1 chữ số",
                "error",
                "TOP_RIGHT",
                2000
            );
            return;
        }
        if (dataUser.nhaplaimatkhaumoi == '') {
            pushNotification(
                "Nhập lại mật khẩu mới",
                "error",
                "TOP_RIGHT",
                2000
            );
            return
        }
        if (dataUser.matkhaumoi != dataUser.nhaplaimatkhaumoi) {
            pushNotification(
                "Hai ô nhập mật khẩu mới phải giống nhau",
                "error",
                "TOP_RIGHT",
                2000
            );
            return
        }


        DanhSachNguoiDungApi.capnhatmatkhaudaily(dataUser.userName, dataUser.matkhaucu, dataUser.matkhaumoi, dataUser.nhaplaimatkhaumoi).then((response) => {
            if (response.status === 200) {
                if (response.data.Error == 200) {
                    pushNotification(
                        response.data.Message,
                        "success",
                        "TOP_RIGHT",
                        2000
                    );
                    setDataUser({
                        ...dataUser,
                        matkhaucu: "",
                        matkhaumoi: "",
                        nhaplaimatkhaumoi: ""
                    })
                }
                else {
                    pushNotification(
                        response.data.Message,
                        "error",
                        "TOP_RIGHT",
                        2000
                    );
                }
            }
        });

    }

    return (
        <LayoutNew >
            <div className="bg-main-content bg-add-content full-main-ver2">
                <div className="niemtin-header">
                    <div className="header-main">
                        <div className="row">
                            <div className="col-sm-9">
                                <div className="title-Search-ver2">
                                    <TitlePage
                                        titlePage="Đổi mật khẩu"
                                        IconTitle={mdiCog}
                                    />
                                </div>
                            </div>
                            <div className="col-sm-3">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-add1">
                    <div class="row-form">
                        <h2 class="title-detail-new">
                            <img src={iconCustomer} alt="#" />
                            Thông tin tài khoản
                        </h2>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group  align-centerNew  ">
                                    <div class="form-new-input-left">
                                        <label class="label-control text-left-main">
                                            Tên đăng nhập
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            value={dataUser.userName}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div class="row-form">
                        <h2 class="title-detail-new">
                            <img src={iconCustomer} alt="#" />
                            Đổi mật khẩu
                        </h2>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group  align-centerNew  ">
                                    <div class="form-new-input-left">
                                        <label class="label-control text-left-main">
                                            Mật khẩu cũ
                                        </label>
                                        <input
                                            type="password"
                                            class="form-control"
                                            value={dataUser.matkhaucu}
                                            onChange={(e) => onChangeText("matkhaucu", e)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group  align-centerNew  ">
                                    <div class="form-new-input-left">
                                        <label class="label-control text-left-main">
                                            Mật khẩu mới
                                        </label>
                                        <input
                                            type="password"
                                            class="form-control"
                                            value={dataUser.matkhaumoi}
                                            onChange={(e) => onChangeText("matkhaumoi", e)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group  align-centerNew  ">
                                    <div class="form-new-input-left">
                                        <label class="label-control text-left-main">
                                            Nhập lại mật khẩu
                                        </label>
                                        <input
                                            type="password"
                                            class="form-control"
                                            value={dataUser.nhaplaimatkhaumoi}
                                            onChange={(e) => onChangeText("nhaplaimatkhaumoi", e)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom-white">
                <div class="footer-bottom ">
                    <div class="footer-bottom-form">
                        <button
                            type="button"
                            class="button-Add-NoIcon bg-blue-main"
                            style={{ marginLeft: "10px" }}
                            onClick={() => onSave()}
                        >
                            Lưu thông tin
                        </button>
                    </div>
                </div>
            </div>
        </LayoutNew>
    );
};
